import { useState } from 'react';

const RELATED_LINES_TAB = 'related-lines';

/**
 * The selected tab of an invoice's detail panel, so another part of the panel
 * can open one (a line's suggestion opens Related lines). A choice belongs to
 * the invoice it was made on: moving to another invoice starts from `initial`
 * again.
 */
export function useInvoiceDetailTab(invoiceId: string, initial: string) {
  const [choice, setChoice] = useState<{
    invoiceId: string;
    value: string;
  } | null>(null);
  const value = choice?.invoiceId === invoiceId ? choice.value : initial;
  const onValueChange = (next: string) => setChoice({ invoiceId, value: next });
  const openRelatedLines = () => onValueChange(RELATED_LINES_TAB);
  return { value, onValueChange, openRelatedLines };
}
